import { render, staticRenderFns } from "./tabletest.vue?vue&type=template&id=2dba8eca&scoped=true&"
import script from "./tabletest.vue?vue&type=script&lang=js&"
export * from "./tabletest.vue?vue&type=script&lang=js&"
import style0 from "./tabletest.vue?vue&type=style&index=0&id=2dba8eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba8eca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
